import { render } from "./HumanTasks.vue?vue&type=template&id=080458bb"
import script from "./HumanTasks.vue?vue&type=script&lang=js"
export * from "./HumanTasks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__